import { inject, Service } from '@angular/core';
import { TranslateService, type InterpolatableTranslationObject, type InterpolationParameters, type Translation } from '@ngx-translate/core';
import { Language } from '@api/models';
import { Observable } from 'rxjs';

@Service()
export class LanguageService {
  private translateService = inject(TranslateService);

  setCurrentLang(lang: Language): Observable<InterpolatableTranslationObject> {
    return this.translateService.use(lang);
  }

  getCurrentLocale(): string {
    const lang = this.getCurrentLang();
    switch (lang) {
      case Language.RU:
        return 'ru-RU';
      case Language.UK:
        return 'uk-UA';
      case Language.EN:
        return 'en-US';
    }
  }

  getRouteLangFromLang(lang: Language): string {
    let routeLang: string = '';

    switch (lang) {
      case Language.UK:
        routeLang = 'ua';
        break;
      case Language.EN:
        routeLang = 'en';
        break;
    }

    return routeLang;
  }

  getCurrentLang(): Language {
    return this.translateService.getCurrentLang() as Language;
  }

  getCurrentRouteLang(): string {
    const currentLang = this.getCurrentLang();
    return this.getRouteLangFromLang(currentLang);
  }

  getTranslation(key: string | string[], interpolateParams?: InterpolationParameters): Observable<Translation> {
    return this.translateService.get(key, interpolateParams);
  }

  getTranslationInstant(key: string | string[], interpolateParams?: InterpolationParameters): Translation {
    return this.translateService.instant(key, interpolateParams);
  }
}
